function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M65.2861 4.97279C65.2861 4.02475 65.5944 2.346 64.9528 1.57142C61.0303 -3.16411 50.7874 9.23748 49.4768 10.9611C35.7796 28.9759 29.0128 51.8153 21.3582 72.8327C19.7477 77.2546 18.1461 81.7394 16.0963 85.9831C15.0817 88.0837 13.2429 92.3892 10.3345 92.4984C7.96541 92.5873 6.25699 89.8584 5.33458 88.1389C2.33403 82.5454 1.27902 75.8237 1.02511 69.551C0.638504 60.0002 4.69012 47.4369 14.9535 44.4C18.2931 43.4118 21.7924 44.1675 25.1676 43.7293C28.0094 43.3604 28.9015 38.9394 29.0009 36.6391C29.182 32.449 25.528 30.9302 21.882 31.8006C20.8248 32.0529 19.5053 32.5658 18.8582 33.5252C17.6253 35.3531 21.9505 34.337 22.1915 34.2917C25.1133 33.7428 28.5839 31.7527 31.5247 31.7527C31.5386 31.7527 30.2282 33.6289 30.4295 34.1959C31.3414 36.7648 40.7193 34.4393 42.4293 34.0761C43.3414 33.8824 45.9374 32.8706 46.9531 33.3815C48.0167 33.9165 41.9982 38.6621 41.9531 38.6991C41.1376 39.3698 29.0427 49.6609 29.0962 49.6937C29.4083 49.8856 29.8398 49.7237 30.1914 49.6219C32.5838 48.9291 39.362 46.1471 40.7151 45.5977C59.4871 37.9758 78.2341 30.288 97 22.6504",
  stroke: "#2F587E",
  strokeLinecap: "round"
});

function SvgSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 93,
    viewBox: "0 0 98 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.50d550be30bcc95d76bb8c1fc92aa5a1.svg";
export { ForwardRef as ReactComponent };